import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBroadcastListingsData } from "../../../redux/ad-blog-reducers/blogSlice";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import CmnFilters from "../../lead-management/common/CmnFilters";
import { broadcast_logs_status } from "../../common-data/DropdowData";

const BroadcastLogsListings = ({
  userInfoData,
  rowData,
  isSentSuccess,
  isSentFailed,
}) => {
  const dispatch = useDispatch();
  const {
    broadcastListings,
    broadcastListingsLoading,
    broadcastListingsError,
  } = useSelector((state) => state.blog);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedBroadcastChannel: "",
    isActive: isSentSuccess
      ? broadcast_logs_status[0]
      : isSentFailed
      ? broadcast_logs_status[1]
      : "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    broadcast_id: rowData?.uid || "",
    channel: allFilters.selectedBroadcastChannel?.value || "",
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const getbroadcastListings = (filters) => {
    dispatch(
      fetchBroadcastListingsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getbroadcastListings(filters);
  }, [filters]);

  useEffect(() => {
    if (
      !broadcastListingsLoading &&
      !broadcastListingsError &&
      broadcastListings?.status &&
      broadcastListings?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: broadcastListings.data,
        pagination:
          broadcastListings?.pagination?.length > 0
            ? broadcastListings.pagination
            : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [broadcastListings, broadcastListingsLoading, broadcastListingsError]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      channel: allFilters.selectedBroadcastChannel?.value || "",
      status: allFilters.isActive?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedBroadcastChannel,
    allFilters.isActive,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    {
      dataField: "name",
      text: "user info",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.name || "NA"}
            <br />
            <small className="underline lowercase">
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "type",
      text: "type",
      formatter: (_, row) => {
        let typeLabel = "NA";
        if (row?.is_email) {
          typeLabel = "Email";
        } else if (row?.is_push) {
          typeLabel = "Push";
        } else if (row?.is_whatsapp) {
          typeLabel = "WhatsApp";
        }
        return <span className="tb-data">{typeLabel}</span>;
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 minWidth100"
            style={{
              background:
                row?.status === "sent"
                  ? "#0A701B"
                  : row?.status === "pending"
                  ? "#FFA500"
                  : "#D90000",
              color: "#fff",
            }}>
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "error",
      text: "failed reason",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.error || "NA"}</span>;
      },
    },
  ];

  return (
    <>
      <CmnFilters
        from="broadcasts-logs-listings"
        userInfoData={userInfoData}
        searchFilterApplied={searchFilterApplied}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickSearch={onClickSearch}
        onClickReset={onResetFilters}
        isLoading={broadcastListingsLoading}
        searchPlaceHolder="Search by user info..."
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt15">
        {broadcastListingsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </>
  );
};

export default BroadcastLogsListings;
